export const getQuickResponses = (state) => state.getIn(['quickResponse', 'items']);



// WEBPACK FOOTER //
// ./src/model/QuickResponse/selector.js